/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageSenderDto
 */
export interface MessageSenderDto {
    /**
     * Sender ID
     * @type {string}
     * @memberof MessageSenderDto
     */
    id: string;
    /**
     * Sender display name
     * @type {string}
     * @memberof MessageSenderDto
     */
    displayName?: string;
    /**
     * Sender photo URL
     * @type {string}
     * @memberof MessageSenderDto
     */
    photoUrl?: string;
    /**
     * Sender role
     * @type {string}
     * @memberof MessageSenderDto
     */
    userType?: MessageSenderDtoUserTypeEnum;
}


/**
 * @export
 */
export const MessageSenderDtoUserTypeEnum = {
    Patient: 'patient',
    Provider: 'provider',
    Admin: 'admin'
} as const;
export type MessageSenderDtoUserTypeEnum = typeof MessageSenderDtoUserTypeEnum[keyof typeof MessageSenderDtoUserTypeEnum];


/**
 * Check if a given object implements the MessageSenderDto interface.
 */
export function instanceOfMessageSenderDto(value: object): value is MessageSenderDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function MessageSenderDtoFromJSON(json: any): MessageSenderDto {
    return MessageSenderDtoFromJSONTyped(json, false);
}

export function MessageSenderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSenderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'userType': json['userType'] == null ? undefined : json['userType'],
    };
}

export function MessageSenderDtoToJSON(json: any): MessageSenderDto {
    return MessageSenderDtoToJSONTyped(json, false);
}

export function MessageSenderDtoToJSONTyped(value?: MessageSenderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'photoUrl': value['photoUrl'],
        'userType': value['userType'],
    };
}

